export default __webpack_public_path__ + "static/media/payment.158f3395.png";